import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-share': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM349.4 185.1c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7h-135.1c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7v-182.5c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7v-101.4c0-7.4 5.8-12.6 12-13.7h55.8v-40.3h-108.5v155.4zM336.1 212.2h-108.5v155.4h108.5v-155.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-share.js
// module id = 774
// module chunks = 0